import { useCallback, useEffect, useState } from 'react';
import { FilterItemVo } from '../ListCheckboxRow';
import { RefinementFacetPriceBucketsArgs } from './RefinementFacetPriceBuckets';

// Temporary hard-coded value until we know how we'll get this from the API
export const BUCKETED_CUSTOM_CODE = 'priceBucket:custom';

export const useRefinementFacetPriceBuckets = ({ options, onChange }: RefinementFacetPriceBucketsArgs) => {
  const [currentOptions, setCurrentOptions] = useState<FilterItemVo[]>(options);
  useEffect(() => {
    setCurrentOptions(options);
  }, [options]);

  const handleSelectedChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { itemId } = event.target.dataset;
      const isCustomSelected = itemId === BUCKETED_CUSTOM_CODE;
      setCurrentOptions(curr =>
        curr.map(item => {
          /**
           * If custom is selected, then all other options should be unselected
           */
          if (isCustomSelected) {
            return { ...item, isActive: item.compositeCode === itemId };
          }
          /**
           * If custom is not selected, then always unselect custom option
           */
          if (!isCustomSelected && item.compositeCode === BUCKETED_CUSTOM_CODE) {
            return { ...item, isActive: false };
          }
          /**
           * If custom is not selected, then toggle the selected option
           * and unselect custom option
           */
          const isActive = item.compositeCode === itemId ? !item.isActive : item.isActive;
          return { ...item, isActive };
        }),
      );
      onChange(event);
    },
    [onChange],
  );

  return {
    currentOptions,
    handleSelectedChange,
  };
};
